export enum DeviceStatus {
	Idle = "Idle",
	Available = "Available",
	NotConfigured = "NotConfigured",
	Operational = "Operational",
	Error = "Error",
}
